import ConduitEvents from '@tagboard/lib-events/dist/esm';

import {
  CONDUIT_PUSHER_AUTH_API,
  NODE_ENV,
  PUSHER_KEY,
  PUSHER_CLUSTER,
} from '@/config/appConfig';

import { storeToRefs } from 'pinia';
import useUserStore from '@/stores/user';

let instance;

const ConduitEventsService = {
  async init(userId) {
    instance = await ConduitEvents.initialize({
      pusherKey: PUSHER_KEY,
      pusherCluster: PUSHER_CLUSTER,
      pusherAuthApi: CONDUIT_PUSHER_AUTH_API,
      userId,
      eventLogging: (NODE_ENV || '').toLowerCase() !== 'production',
    });

    return instance;
  },

  /**
   * @param {string} eventName - Format: `{source}.{action/category}.{eventName}` Example: 'producer.action.sportradar-element-added' or 'producer.event.production-went-live'
   * @param {object} eventData - The event data payload
   * @param {object} [eventContext] - Additional event context data
   * @returns {*}
   */
  track: (eventName, eventData, eventContext) => {
    const { currentTeamId, userId, isStaff } = storeToRefs(useUserStore());
    return instance?.track(eventName, eventData, {
      ownerId: currentTeamId.value,
      userId: userId.value,
      currentTeamId: currentTeamId.value,
      isStaff: isStaff.value,
      ...eventContext,
    });
  },

  Events: {
    // Poll Editor
    Polls_AddedRound: 'polls.added.round',
    Polls_AddedQuestion: 'polls.added.question',
    Polls_AddedDisplay: 'polls.added.display',
    Polls_ResetRound: 'polls.reset.round',
    Polls_ClickedAnalytics: 'polls.clicked.analytics',
    Polls_AddedElementToDisplay: 'polls.added.element-to-display',
    Polls_CopiedEmbedCode: 'polls.copied.embed-code',
    Polls_CopiedPageUrl: 'polls.copied.page-url',
    Polls_AddedToPage: 'polls.added.to-page',

    // Page Editor
    Pages_AddedElement: 'pages.element.added',
    Pages_EnabledPII: 'pages.element.enabled-pii',
  },
};

export default ConduitEventsService;
